import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authService from "../../api-authorization/AuthorizeService";
import { CreateAsyncStatusHandlers } from "../../../app/SliceUtils";

export const fetchSearchStudents = createAsyncThunk(
    '/api/search/students/isActive',
    async (isActive, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(window.Config.apiUrl + `api/search/students/${isActive}`, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            const errorCode = await response.json();
            return rejectWithValue(errorCode);
        } else {
            return response.json();
        };
    }
);

export const fetchStudentInfoSettings = createAsyncThunk(
    'api/search/studentInfoSettings',
    async (args, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(window.Config.apiUrl + 'api/search/studentInfoSettings', {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const fetchSearchStudent = createAsyncThunk(
    '/api/search/student/studentId',
    async ({ studentId, employeeId, departmentId }, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        var urlParams = departmentId !== null ? `api/search/student/${studentId}/${employeeId}/${departmentId}` : `api/search/student/${studentId}/${employeeId}`;
        const response = await fetch(window.Config.apiUrl + urlParams, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const fetchSearchStudentTimetable = createAsyncThunk(
    '/api/timetable/employee',
    async ({ studentId, departmentId }, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const urlParams = departmentId !== null ? `api/timetable/employee/${studentId}/${departmentId}` : `api/timetable/employee/${studentId}`;
        const response = await fetch(window.Config.apiUrl + urlParams, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const fetchSearchStudentAttendances = createAsyncThunk(
    '/api/attendance/student/studentId/departmentId',
    async ({ studentId, departmentId }, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const urlParams = departmentId !== null ? `api/attendance/student/${studentId}/${departmentId}` : `api/attendance/student/${studentId}`;
        const response = await fetch(window.Config.apiUrl + urlParams, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const putStudentAttendance = createAsyncThunk(
    "/api/attendance/student/put",
    async (studentAttendance, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(window.Config.apiUrl + `api/attendance/student`, {
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: !token ? {} : `Bearer ${token}`,
            }),
            method: "PUT",
            redirect: "follow",
            body: JSON.stringify(studentAttendance),
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        }
    }
);

export const putAbsenceBlock = createAsyncThunk(
    "/api/attendance/block/attendanceId",
    async (attendanceId, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(window.Config.apiUrl + `api/attendance/block/${attendanceId}`, {
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: !token ? {} : `Bearer ${token}`,
            }),
            method: "PUT",
            redirect: "follow",
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        }
    }
);

export const fetchSearchStudentProgramOverview = createAsyncThunk(
    '/api/search/programOverview/studentId/departmentId',
    async ({ studentId, departmentId }, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        var urlParams = departmentId !== null ? `api/search/programOverview/${studentId}/${departmentId}` : `api/search/programOverview/${studentId}`;
        const response = await fetch(window.Config.apiUrl + urlParams, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const fetchSearchStudentSchedule = createAsyncThunk(
    '/api/schedule/student/studentId',
    async (studentId, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(window.Config.apiUrl + `api/schedule/student/${studentId}`, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

// History
export const fetchSearchStudentHistory = createAsyncThunk(
    '/api/history/student/studentId',
    async ({ studentId, departmentId }, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const urlParams = departmentId !== null ? `api/history/student/${studentId}/${departmentId}` : `api/history/student/${studentId}`;

        const response = await fetch(window.Config.apiUrl + urlParams, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const fetchSearchStudentProgramHistory = createAsyncThunk(
    '/api/history/program/studentId/programId/departmentId',
    async ({ studentId, programId, departmentId }, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const urlParams = departmentId !== null ? `api/history/program/${studentId}/${programId}/${departmentId}` : `api/history/program/${studentId}/${programId}`;

        const response = await fetch(window.Config.apiUrl + urlParams, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': !token ? {} : `Bearer ${token}`
            }),
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

// Remarks
export const putStudentRemark = createAsyncThunk(
    "/api/remark/student/put",
    async (updatedRemark, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(
            window.Config.apiUrl + "api/remark/student",
            {
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: !token ? {} : `Bearer ${token}`,
                }),
                method: "PUT",
                redirect: "follow",
                body: JSON.stringify(updatedRemark),
            }
        );

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const postStudentRemark = createAsyncThunk(
    "/api/remark/student/post",
    async (newRemark, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(
            window.Config.apiUrl + "api/remark/student",
            {
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: !token ? {} : `Bearer ${token}`,
                }),
                method: "POST",
                redirect: "follow",
                body: JSON.stringify(newRemark),
            }
        );

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);

export const deleteStudentRemark = createAsyncThunk(
    "/api/remark/student/delete",
    async (remarkId, { rejectWithValue }) => {
        const token = await authService.getAccessToken();
        const response = await fetch(
            window.Config.apiUrl + `api/remark/student/${remarkId}`,
            {
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: !token ? {} : `Bearer ${token}`,
                }),
                method: "DELETE",
                redirect: "follow",
            }
        );

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        } else {
            return response.json();
        };
    }
);


export const searchStudentSlice = createSlice({
    name: 'searchStudent',
    initialState: {
        // Student progress and info
        searchStudents: null,
        searchStudentsStatus: null,
        searchStudent: null,
        searchStudentStatus: null,

        // Register
        studentRegisterFilter: '',
        studentRegisterPage: 'REGISTER',
        studentRegisterParentCheck: true,
        studentRegisterReasonMode: false,

        // Timetable
        searchStudentTimetable: null,
        searchStudentTimetableStatus: null,

        // Attendance
        searchStudentAttendance: null,
        searchStudentAttendanceStatus: null,
        putStudentAttendanceStatus: null,
        putAbsenceBlockStatus: null,
        selectedAttendance: null,
        failedAttendance: false,

        // Program overview
        searchStudentProgramOverview: null,
        searchStudentProgramOverviewStatus: null,

        // Schedule
        searchStudentSchedule: null,
        searchStudentScheduleStatus: null,

        // StudentInfo
        studentInfo: null,
        studentInfoStatus: null,

        // History
        searchStudentHistory: null,
        searchStudentHistoryStatus: null,
        searchStudentProgramHistory: null,
        searchStudentProgramHistoryStatus: null,

        // Remarks
        putStudentRemarkStatus: null,
        postStudentRemarkStatus: null,
        deleteStudentRemarkStatus: null,
    },
    reducers: {
        // Attendance
        setSelectedAttendance: (state, action) => {
            state.selectedAttendance = action.payload;
        },
        setFailedAttendance: (state, action) => {
            state.failedAttendance = action.payload;
        },
        resetAttendanceStatus: (state, action) => {
            state.putStudentAttendanceStatus = null;
            state.putAbsenceBlockStatus = null;
        },

        // Register
        setStudentRegisterFilter: (state, action) => {
            state.studentRegisterFilter = action.payload;
        },
        setStudentRegisterPage: (state, action) => {
            state.studentRegisterPage = action.payload;
        },
        setStudentRegisterParentCheck: (state) => {
            state.studentRegisterParentCheck = !state.studentRegisterParentCheck;
        },
        setStudentRegisterReasonMode: (state) => {
            state.studentRegisterReasonMode = !state.studentRegisterReasonMode;
        },

        // Remarks
        resetRemarkStatus: (state) => {
            state.putStudentRemarkStatus = null;
            state.postStudentRemarkStatus = null;
            state.deleteStudentRemarkStatus = null;
        },

        resetSearchStudentHistory: (state) => {
            state.searchStudentHistory = null;
            state.searchStudentHistoryStatus = null;
            state.searchStudentProgramHistory = null;
            state.searchStudentProgramHistoryStatus = null;
        },
    },
    extraReducers: (builder) => {
        // Search students
        CreateAsyncStatusHandlers(builder, fetchSearchStudents, 'searchStudentsStatus', (state, action) => {
            state.searchStudents = action.payload;
        });

        // Search student
        CreateAsyncStatusHandlers(builder, fetchSearchStudent, 'searchStudentStatus', (state, action) => {
            state.searchStudent = action.payload;
        });

        // Student timetable
        CreateAsyncStatusHandlers(builder, fetchSearchStudentTimetable, 'searchStudentTimetableStatus', (state, action) => {
            state.searchStudentTimetable = action.payload;
        });

        // Student attendance
        CreateAsyncStatusHandlers(builder, fetchSearchStudentAttendances, 'searchStudentAttendanceStatus', (state, action) => {
            state.searchStudentAttendance = action.payload;
        });
        CreateAsyncStatusHandlers(builder, putStudentAttendance, 'putStudentAttendanceStatus');
        CreateAsyncStatusHandlers(builder, putAbsenceBlock, 'putAbsenceBlockStatus');

        // Student program overview
        CreateAsyncStatusHandlers(builder, fetchSearchStudentProgramOverview, 'searchStudentProgramOverviewStatus', (state, action) => {
            state.searchStudentProgramOverview = action.payload;
        });

        // Student schedule
        CreateAsyncStatusHandlers(builder, fetchSearchStudentSchedule, 'searchStudentScheduleStatus', (state, action) => {
            state.searchStudentSchedule = action.payload;
        });

        // Student info
        CreateAsyncStatusHandlers(builder, fetchStudentInfoSettings, 'studentInfoStatus', (state, action) => {
            state.studentInfo = action.payload;
        });

        // Student history
        CreateAsyncStatusHandlers(builder, fetchSearchStudentHistory, 'searchStudentHistoryStatus', (state, action) => {
            state.searchStudentHistory = action.payload;
        });

        // Student program history
        CreateAsyncStatusHandlers(builder, fetchSearchStudentProgramHistory, 'searchStudentProgramHistoryStatus', (state, action) => {
            state.searchStudentProgramHistory = action.payload;
        });

        // Student Remarks
        CreateAsyncStatusHandlers(builder, putStudentRemark, 'putStudentRemarkStatus');
        CreateAsyncStatusHandlers(builder, postStudentRemark, 'postStudentRemarkStatus');
        CreateAsyncStatusHandlers(builder, deleteStudentRemark, 'deleteStudentRemarkStatus');
    }
});

export const {
    setSelectedAttendance,
    setFailedAttendance,
    resetAttendanceStatus,
    setStudentRegisterFilter,
    setStudentRegisterPage,
    setStudentRegisterParentCheck,
    setStudentRegisterReasonMode,
    resetRemarkStatus,
    resetSearchStudentHistory
} = searchStudentSlice.actions;

export default searchStudentSlice.reducer;